
/**
 * "name": "Joe Smith"
 * "state": "NV"
 * "zip": "89129",
 * "type": "P",  // (account type P=personal, B=business)
 * AccountPermissions[{
 *    OTP=OK,  // eligible for onetime payment  
 *    NRG=OK, // eligible for energy share  
 *    OWN=OK, // owner of the account (myaccount specific)
 *    ADD=AccountAlreadyAssociated,  // eligible for myaccount (myaccount specific)
 *    APP=OK,  // eligible for automated payment plan  
 *    PE=OK, // eligible for payment extention
 *    LIRA=AccountNotInArizona, // eligible for LIRA (AZ customers only)
 *    APPCanEnroll=OK, // can enroll in APP
 *    CARE=AccountNotInCalifornia, // eligible for CARE (CA customers only)
 *    APPCanTerminate=AppNotEnrolled, // can terminate APP (myaccount specific)
 *    EPPCanEnroll=OK, // can enroll for EPP      
 *    EPP=OK, // eligible for equal payment plan
 *    EPPCanTerminate=EppNotEnrolled, // can terminate EPP (myaccount specific)
 *    SSM=OK, // eligible for stop, start or move transaction
 *    PAP=OK // eligible for paperless billing
 * }]
 */

angular.module('app.services.session_service', ['base64']).factory('SessionService',
    function($rootScope, $base64, $log) {

  $log.debug('SessionService(): loading');

  var _sessionService = {};

  /*---------------- COOKIE SUPPORT --------------------------------------------------------------------------- */
  // Checks the browser to see if cookies are supported
  _sessionService.browserSupportsCookies = function() {
    try {
      return navigator.cookieEnabled ||
        ("cookie" in document && (document.cookie.length > 0 ||
        (document.cookie = "test").indexOf.call(document.cookie, "test") > -1));
    } catch (e) {
      $rootScope.$broadcast('LocalStorageModule.notification.error',e.message);
      return false;
    }
  };

  // Directly adds a value to cookies
  _sessionService.addToCookies = function (key, value) {
    if (typeof value == "undefined") return false;

    if (!_sessionService.browserSupportsCookies()) {
      $rootScope.$broadcast('LocalStorageModule.notification.error','COOKIES_NOT_SUPPORTED');
      return false;
    }

    try {
      $log.debug('-> Adding cookie '+key+" "+value);
      if (value === null) {
        value = ';expires=Thu, 01 Jan 1970 00:00:01 GMT;';
      }
      document.cookie = key + "=" + value;
    } catch (e) {
      $rootScope.$broadcast('LocalStorageModule.notification.error',e.message);
      return false;
    }
    return true;
  };

  // Directly get a value from a cookie
  _sessionService.getFromCookies = function (key) {
    if (!_sessionService.browserSupportsCookies()) {
      $rootScope.$broadcast('LocalStorageModule.notification.error','COOKIES_NOT_SUPPORTED');
      return false;
    }

    var cookies = document.cookie.split(';');
    for(var i=0;i < cookies.length;i++) {
      var thisCookie = cookies[i];
      while (thisCookie.charAt(0)==' ') {
        thisCookie = thisCookie.substring(1,thisCookie.length);
      }
      if (thisCookie.indexOf(key+'=') === 0) {
        var value = thisCookie.substring(key.length+1,thisCookie.length);
        if (key === 'location-swg')
          return value;

        return $base64.decode(decodeURIComponent(value));
      }
    }
    return null;
  };

  _sessionService.removeFromCookies = function (key) {
    _sessionService.addToCookies(key, null);
  };

  _sessionService.setCurrentLocation = function (locationStr) {
    // Set current global variables
    if (locationStr == "CA") {
      $rootScope.userState = "ca";
      $rootScope.userLocation = "California";
    }
    else if (locationStr == "AZ") {
      $rootScope.userState = "az";
      $rootScope.userLocation = "Arizona";
    }
    else {
      locationStr = "NV";
      $rootScope.userState = "nv";
      $rootScope.userLocation = "Nevada";
    }

    // Save location in a cookie
    _sessionService.addToCookies("location-swg",locationStr);
  };

  _sessionService.getCookieData = function () {
    var userRec = {};
    try {
      userRec = JSON.parse( _sessionService.getFromCookies("myaccount-swg") );
    } catch (e) {
      $log.debug('Could not parse the user cookie');
      $log.debug(e);
    }

    if (userRec) {
      // if a location sent as part of login it will override any last selected state
      if (userRec.state && !locationStr) {
        _sessionService.setCurrentLocation(userRec.state);
      }

      if (userRec.name) {
        $rootScope.userDisplayName = userRec.name;
      }
      return;
    }

    var locationStr =  _sessionService.getFromCookies("location-swg");
    if (locationStr && locationStr.length > 0) {
      _sessionService.setCurrentLocation(locationStr);
      return;
    }

    // Can't find anything, set to Nevada
    $rootScope.userLocation = "Nevada";
    $rootScope.userState = "nv";
    $rootScope.userDisplayName = "";
  };

  _sessionService.init = function () {
    $log.debug('SessionService(): init()');
    this.getCookieData();
  };

  $rootScope.$on('loginSessionExpired', function (evt, data, fn) {
    if (fn) {
      $apply(fn);
    }
  });

  return _sessionService;
});